import {
	createPlugin,
	createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const guidelinesPlugin = createPlugin({
	id: 'guidelines',
	routes: {
		root: rootRouteRef,
	},
});

export const GuidelinesPage = guidelinesPlugin.provide(
	createRoutableExtension({
		name: 'GuidelinesPage',
		component: () =>
			import('./components/GuidelinesPage').then(m => m.GuidelinesPage),
		mountPoint: rootRouteRef,
	}),
);
